const cleanPart = (value = '') => {
  const text = String(value).trim();
  if (!text) return '';
  if (/^(null|none|undefined|nan)$/i.test(text)) return '';
  return text;
};

const slugifyPart = (value = '') =>
  cleanPart(value)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();

export const buildArtistSlug = (artist = {}) => {
  const mainProfession = artist.display_profession || artist.category || artist.subcategory;
  const parts = [artist.name, mainProfession, artist.city]
    .map(slugifyPart)
    .filter(Boolean);

  return parts.join('-') || artist.id || '';
};

export const artistProfilePath = (artist = {}) => `/artist/${artist.seo_slug || artist.slug || buildArtistSlug(artist) || artist.id}`;
